'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _momentTimezone = require('moment-timezone');

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {

    props: ["currentFarm"],

    computed: {
        player: function player() {
            return this.$refs.videoPlayer.player;
        },
        timelapse: function timelapse() {
            return this.currentFarm.lastIndicators[0].timelapse;
        },
        playerOptions: function playerOptions() {
            return {

                start: 0,
                playsinline: false,
                controls: false, // window.GLOBAL_CONFIG.isShop ? false : 'simple',
                autoplay: true, // window.GLOBAL_CONFIG.isShop,
                loop: true, // window.GLOBAL_CONFIG.isShop,
                muted: true,
                language: 'en',
                playbackRates: [0.7, 1.0, 1.5, 2.0],
                sources: [{
                    type: "video/mp4",
                    src: this.timelapse.videoUrl
                }],
                poster: this.timelapse.thumbnailUrl
            };
        },
        getDate: function getDate() {
            var timezone = this.currentFarm.config.location.timezone ? this.currentFarm.config.location.timezone : 'Europe/Paris';
            var fromDate = (0, _momentTimezone2.default)(this.timelapse.begin_at).tz(timezone);
            var toDate = (0, _momentTimezone2.default)(this.timelapse.end_at).tz(timezone);
            var fromMonth = fromDate.format("MMM") + ".";
            var toMonth = toDate.format("MMM") + ".";
            if (fromDate === toMonth) return fromDate.format("DD") + " > " + toDate.format("DD") + toMonth;else return fromDate.format("DD") + " " + fromMonth + " > " + toDate.format("DD") + " " + toMonth;
        }
    },

    methods: {
        onPlayerPause: function onPlayerPause(player) {}
    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib?{"presets":["es2015","stage-0"],"plugins":["transform-class-properties","transform-function-bind"]}!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/timelapse/TimelapseComponent.vue
// module id = 405
// module chunks = 0